import React, { useState, Fragment } from "react";

import { Menu, Transition } from "@headlessui/react";
import { ReactSVG } from "react-svg";
import { formatPhone } from "../../../../helpers/functions";
import ContactInformationCreate from "./ContactInformationCreate";
import { stateOptions, phoneOptions, addressOption, longTermOption } from "../../create/options";

const ContactInformation = ({ patient, navigateToAlternateCaregiver }) => {
  const contactInfo = patient.contactInfo;
  const [showCreateSlider, setShowCreateSlider] = useState(false);

  const findCareGiverPrimaryContact =
    patient.caregiver.length > 0 &&
    patient.caregiver.find(
      (_caregiver) => _caregiver.contactInfo.primaryContact === true
    );
  /*
   If the step is skipped, the patient has no 'caregiver' set.
   Thus everything is undefined, THUS no values are shown if && short circuit is used.
   -
   This should be looking for the primary contact badge not the caregiver, 
   furthering the problem of not having an area to select the patient as primary contact AND explaining what 
   primary contact means in the alt caregiver step
   (EG. You have already chosen the patient as the primary contact...)
  */
  const manageClick = () => {
    document.body.classList.toggle("overflow-hidden");
  };
  return (
    <div className="mainCard !w-[550px] !h-fit !min-h-[613px]">
      {(
        <ContactInformationCreate
          open={showCreateSlider}
          onClose={(value) => {
            setShowCreateSlider(value);
          }}
          patient={contactInfo}
        />
      )}
      <div className="flex items-center justify-between h-[72px] px-6 py-3 border-b border-gray-100 bg-gray-20">
        <h4 className="text-lg font-bold text-teal-600">Contact Information</h4>
        <Menu as="div" className="relative inline-block text-left">
          <div>
            <Menu.Button>
              <ReactSVG
                src={`/icons/triple-dot.svg`}
                className={`flex text-black !items-center w-6 scale-x-[1.4] scale-y-[1.4]`}
              />
            </Menu.Button>
          </div>
          <Transition
            as={Fragment}
            enter="transition ease-out duration-100"
            enterFrom="transform translate-y-2 opacity-0 scale-95"
            enterTo="transform translate-y-0 opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform translate-y-0 opacity-100 scale-100"
            leaveTo="transform translate-y-2 opacity-0 scale-95"
          >
            <Menu.Items className="absolute top-full left-1/2 -translate-x-1/2 mt-1 min-w-[80px] w-auto origin-top bg-white divide-y divide-gray-20 rounded-md shadow-lg ring-1 ring-black ring-opacity-5">
              <Menu.Item>
                <button
                  className="block text-left w-[80px] h-[38px] px-[10px] py-[10px] flex items-center gap-[10px] border-b border-b-neutral-70 hover:bg-gray-50"
                  onClick={() => {
                    setShowCreateSlider(true);
                  }}
                >
                  Edit
                </button>
              </Menu.Item>
            </Menu.Items>
          </Transition>
        </Menu>
      </div>
      <div className="px-6 py-3.5">
        <div className="grid grid-cols-1">
          <div>
            <p className="mb-1.5 text-sm text-gray-700">Email</p>
            <p className="font-bold text-gray-800 text-body-md">
              {/* {findCareGiverPrimaryContact?.contactInfo?.email || */}
              {contactInfo.email ||
                "No Email Information"}
            </p>
          </div>
          <div className="border-b border-b-gray-100 mb-3 pt-2.5"></div>
          <div className="grid grid-cols-2">
            <div>
              {
                !contactInfo.noPhone &&
                  // Currently saving as "", commented out for proper display
                  // contactInfo.primaryPhoneCountryCode &&
                  contactInfo.primaryPhone
                  ? (
                    <>
                      <p className="mb-1.5 text-sm text-gray-700">Primary Phone</p>
                      <p className="font-bold text-gray-800 text-body-md">
                        {/* {`+${contactInfo.primaryPhoneCountryCode} ${formatPhone(contactInfo.primaryPhone)}`} */}
                        {`${formatPhone(contactInfo.primaryPhone)}`}
                      </p>
                    </>
                  )
                  // : findCareGiverPrimaryContact &&
                  //   findCareGiverPrimaryContact.contactInfo.primaryPhoneCountryCode &&
                  //   findCareGiverPrimaryContact.contactInfo.primaryPhone
                  // ? (
                  //   <>
                  //     <p className="mb-1.5 text-sm text-gray-700">Primary Contact Phone</p>
                  //     <p className="font-bold text-gray-800 text-body-md">
                  //       {`${findCareGiverPrimaryContact.contactInfo.primaryPhoneCountryCode} ${formatPhone(findCareGiverPrimaryContact.contactInfo.primaryPhone)}`}
                  //     </p>
                  //   </>
                  // ) 
                  : (
                    <>
                      <p className="mb-1.5 text-sm text-gray-700">Phone</p>
                      <p className="font-bold text-gray-800 text-body-md">No Phone Information</p>
                    </>
                  )
              }
            </div>
            {!contactInfo.noPhone && contactInfo.secondaryPhone ? (
              <div className="">
                <p className="mb-1.5 text-sm text-gray-700">Secondary Phone</p>
                <p className="font-bold text-gray-800 text-body-md">
                  {/* {`+${contactInfo.secondaryPhoneCountryCode} ${formatPhone(contactInfo.secondaryPhone)}`} */}
                  {`${formatPhone(contactInfo.secondaryPhone)}`}
                </p>
              </div>
            ) : null}
          </div>
          <div className="border-b border-b-gray-100 mb-3 pt-2.5"></div>

          <div className="col-span-full">
            <p className="mb-1.5 text-sm text-gray-700">Address</p>
            <div className="font-bold text-gray-800 capitalize text-body-md">
              <div>
                {contactInfo.longTermCare ? (
                  contactInfo.nameOfFacility ? (
                    <>
                      <p className="font-bold text-gray-800 text-body-md">
                        <span className="px-2 py-1 w-max font-medium bg-gray-50 relative bottom-0.5 text-teal-300 text-[10px] border rounded-full">
                          {`Long Term Care`}
                        </span>
                        <br />
                        {[
                          contactInfo.nameOfFacility,
                          contactInfo.address && contactInfo.address,
                          contactInfo.poBox && `PO Box: ${contactInfo.poBox}`,
                          contactInfo.unitNumber && `Unit # ${contactInfo.unitNumber}`,
                        ]
                          .filter(Boolean)
                          .join(', ')}
                      </p>
                    </>
                  ) : (
                    <>
                      <p className="font-bold text-gray-800 text-body-md">
                        <span className="px-2 py-1 w-max font-medium bg-gray-50 relative bottom-0.5 text-teal-300 text-[10px] border rounded-full">
                          {`Long Term Care`}
                        </span>
                      </p>
                      <p>
                      {[
                        contactInfo.address,
                        contactInfo.poBox && `PO Box: ${contactInfo.poBox}`,
                        contactInfo.unitNumber && `Unit # ${contactInfo.unitNumber}`,
                      ]
                        .filter(Boolean)
                        .join(', ')}
                      </p>
                    </>
                  )
                ) : <></>}

              </div>
              {!contactInfo.noAddress && !contactInfo.longTermCare &&
                <>
                  <p>
                    {/* {(findCareGiverPrimaryContact?.contactInfo?.address || contactInfo.address) 
                  ? `${findCareGiverPrimaryContact?.contactInfo?.address || contactInfo.address}, `
                  : ''} */}
                    {[
                      contactInfo.address,
                      contactInfo.poBox && `PO Box: ${contactInfo.poBox}`,
                      contactInfo.unitNumber && `Unit # ${contactInfo.unitNumber}`,
                    ]
                      .filter(Boolean)
                      .join(', ')}
                  </p>
                </>
              }
            </div>
          </div><div className="border-b border-b-gray-100 mb-3 pt-2.5"></div>
          <div className="grid grid-cols-2">
            <div>
              <p className="mb-1.5 text-sm text-gray-700">City/Town</p>
              <p className={`text-body-md font-bold text-gray-800 capitalize`}>
                {contactInfo.city}
              </p>
            </div>
            <div>
              <p className="mb-1.5 text-sm text-gray-700">
              Province
              </p>
              <p className={`text-body-md font-bold text-gray-800 capitalize`}>
                {
                  stateOptions.find(
                    (option) =>
                      option.value === patient.contactInfo.province
                  ).label
                  // --Cannot read properties of undefined (reading 'label')------------
                }
              </p>
            </div>
          </div>
          <div className="border-b border-b-gray-100 mb-3 pt-2.5"></div>
          <div className="grid grid-cols-2">
            <div>
              <p className="mb-1.5 text-sm text-gray-700">Postal Code</p>
              <p
                className={`text-body-md font-bold text-gray-800 capitalize`}
              >{contactInfo?.postalCode 
                ? contactInfo.postalCode.replace(/\s/g, '').replace(/(.{3})(.*)/, '$1 $2').trim()
                : ""}
                    </p>
            </div>
            <div>
              <p className="mb-1.5 text-sm text-gray-700">
                Country
              </p>
              <p
                className={`text-body-md font-bold text-gray-800 capitalize`}
              >
                {contactInfo.country}
              </p>
            </div>
          </div>
          <div className="border-b border-b-gray-100 mb-3 pt-2.5"></div>
          <div className="col-span-full">
            <p className="mb-1.5 text-sm text-gray-700">Time Zone</p>
            <p className="text-body-md font-bold text-gray-800 capitalize min-h-[22px]">
              {contactInfo?.timeZone}
            </p>
          </div>
          <div className="border-b border-b-gray-100 mb-3 pt-2.5"></div>
          <div className="col-span-full">
            <p className="mb-1.5 text-sm text-gray-700">Comments</p>
            <p className="font-bold text-gray-800 capitalize text-body-md">
              {/* {findCareGiverPrimaryContact?.contactInfo?.comments || contactInfo.comments} */}
              {patient.comments || contactInfo.comments}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactInformation;
